import React from 'react';
import { Box } from '@mui/material';
import ChatBot from '../components/ChatBot/ChatBot';
import { useEntityContext } from '../components/EntityContextSwitch';

/**
 * Full-page Chat route component
 * Renders the ChatBot component in full-page mode with entity context
 */
export const Chat = () => {
  const { currentEntity } = useEntityContext();

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        m: 0,
        p: 0
      }}
    >
      <ChatBot
        fullPage
        entityId={currentEntity?.id}
        entityName={currentEntity?.name}
      />
    </Box>
  );
};

export default Chat;
